if (!window.hfcCartBundleUpsellLoaded) {
  window.hfcCartBundleUpsellLoaded = true;

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-cart-bundle-select]');
    if (!select) return;

    const item = select.closest('[data-cart-bundle-item]');
    const option = select.selectedOptions?.[0];
    if (!item || !option) return;

    const image = item.querySelector('.cart-bundle-upsell__image');
    const price = item.querySelector('[data-cart-bundle-price]');
    const button = item.querySelector('[data-cart-bundle-add]');
    const title = item.querySelector('.cart-bundle-upsell__name');
    const media = item.querySelector('.cart-bundle-upsell__media');

    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.srcset = option.dataset.image;
    }

    if (title && option.dataset.title) {
      title.textContent = option.dataset.title;
    }

    if (title && option.dataset.url) {
      title.href = option.dataset.url;
    }

    if (media && option.dataset.url) {
      media.href = option.dataset.url;
    }

    if (price) {
      price.innerHTML = `
        <span>${option.dataset.bundlePrice}</span>
        <s>${option.dataset.price}</s>
      `;
    }

    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Add' : 'Sold out';
    }
  });

  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest('[data-cart-bundle-add]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const cartItems = document.querySelector('cart-items-component');
      const sectionId = cartItems?.dataset.sectionId;

      const item = button.closest('[data-cart-bundle-item]');
      const select = item?.querySelector('[data-cart-bundle-select]');
      const variantId = select?.value;

      if (!sectionId || !variantId || button.disabled) return;

      button.disabled = true;
      button.innerHTML = '<span class="cart-bundle-spinner"></span>';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            sections: sectionId,
            sections_url: window.location.pathname,
          }),
        });

        const data = await response.json();
        
          if (!response.ok) {
            throw new Error(data?.description || 'Add failed');
          }

          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: String(variantId),
                data: {
                  source: 'cart-bundle-upsell',
                  itemCount: 1,
                  variantId: String(variantId),
                  sections: data.sections,
                },
              },
            })
          );

        setTimeout(() => {
          const drawer = document.querySelector('cart-drawer-component');

          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        }, 50);
        
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.textContent = 'Add';
      }
    },
    true
  );
}